import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { empty_pagination } from '../../constants/empty_pagination';
import Agent from '../agent';

const initialState = {
  loading: false,
  quarterly_performance: [],
  transactions: [],
  chain_asset_breakdown: [],
  token_chain_breakdown: [],
  chain_total_amounts: [],
  tokenDictionary: {},
  performance_summary: false,
  subpages_performance_summary: false,
  pagination: { pages: 0 },
  errors: {},
  redirectTo: null,
  account_performance_summary: {},
};

/**
 * Fetches and handles all the chain overviews
 */
export const getDefiChain = createAsyncThunk(
  'defi/overview/chain',
  async (data, { rejectWithValue }) => {
    return Agent.Defi.Overview.chain()
      .then((response) => {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        if (!error.response) {
          return rejectWithValue({ errors: { [error.name]: error.message } });
        }
        return rejectWithValue(error.response.body);
      });
  }
);

export const getQuarterlyPerformance = createAsyncThunk(
  'defi/quarterlyPerformance',
  async (data, { rejectWithValue }) => {
    try {
      const { data } = await Agent.Defi.QuarterlyPerformance.get();
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

export const getDefiSubpagesOverview = createAsyncThunk(
  'defi/subpages/overview/get',
  async (wallet_address, { rejectWithValue }) => {
    try {
      const { data } = await Agent.Defi.Overview.getSubpagesOverview(wallet_address);
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

/**
 * Fetches and handles all the chain overviews
 */
export const getDefiPerformanceSummary = createAsyncThunk(
  'defi/performanceSummary',
  async (wallet_address, { rejectWithValue }) => {
    try {
      const { data } = await Agent.Defi.Overview.performanceSummary();
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

export const getDefiPerformanceSummaryByAccount = createAsyncThunk(
  'defi/performanceSummary/getOne',
  async (wallet_address, { rejectWithValue }) => {
    try {
      const { data } = await Agent.Defi.performanceSummaryByAccount.get(wallet_address);
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

const defiOverviewSlice = createSlice({
  name: 'defi/overview',
  initialState,
  reducers: {
    setLoading(state) {
      state.loading = true;
    },
    // reset: () => initialState
  },
  extraReducers: {
    // these are the actions generated by the above createAsyncThunk of redux/toolkit

    [getDefiChain.pending]: (state) => {
      state.loading_chain_data = true;
    },
    [getDefiChain.fulfilled]: (state, action) => {
      state.loading_chain_data = false;
      let {
        chain_asset_breakdown,
        chain_total_amounts,
        token_chain_breakdown,
        protocol_chain_breakdown,
        available_chains,
      } = action.payload;
      state.chain_asset_breakdown = chain_asset_breakdown || [];
      state.available_chains = available_chains || [];
      state.token_chain_breakdown = token_chain_breakdown || [];
      state.chain_total_amounts = chain_total_amounts || [];
      state.protocol_chain_breakdown = protocol_chain_breakdown || [];
    },
    [getDefiChain.rejected]: (state, action) => {
      state.loading_chain_data = false;
      state.errors = action?.payload?.errors || {};
    },

    // Querterly performance
    [getQuarterlyPerformance.pending]: (state) => {
      state.loading = true;
    },

    [getQuarterlyPerformance.fulfilled]: (state, action) => {
      state.loading = false;
      state.quarterly_performance = action?.payload?.data?.quarterly_performance || [];
    },

    [getDefiSubpagesOverview.pending]: (state) => {
      state.loading = true;
    },

    [getDefiSubpagesOverview.fulfilled]: (state, action) => {
      state.subpages_performance_summary = action?.payload?.data || false;
    },

    [getDefiSubpagesOverview.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },

    [getDefiPerformanceSummaryByAccount.pending]: (state) => {
      state.loading = true;
    },

    [getDefiPerformanceSummaryByAccount.fulfilled]: (state, action) => {
      state.account_performance_summary = action?.payload?.data?.performance_summary || {};
    },

    [getDefiPerformanceSummaryByAccount.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },

    [getDefiPerformanceSummary.pending]: (state) => {
      state.loading = true;
    },

    [getDefiPerformanceSummary.fulfilled]: (state, action) => {
      state.performance_summary = action?.payload?.data?.performance_summary || {};
    },

    [getDefiPerformanceSummary.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },
  },
});

export const defiOverviewSelector = (state) => state.defiOverview;

export const { reducer, actions } = defiOverviewSlice;
